<template>
  <div class="hotel">
    <div class="banner">
      <img :src="`${showImgUrl}${currentHotel.hotelImg}`" alt />
      <div class="detail">
        <div class="hotel-name">
          <p class="h-name">{{currentHotel.hotelName}}</p>
          <p class="star">{{ currentHotel.star}}</p>
        </div>
        <div class="instruction detail-div" :class="{'height-limit': !showMore, 'one': !showMore}" >
          <div>
            <img src="./static/lou.jpeg" alt />
            <p class="detail-p"> {{ currentHotel.description }}</p>
          </div>
          <span @click="showDecrip" >详情></span>
        </div>
        <div class="instruction two" @click="goMap(currentHotel.hotelAddress)">
          <div>
            <img src="./static/area.jpeg" alt />
            <p class="address-p">{{currentHotel.hotelAddress}}</p>
          </div>
          <span>地图></span>
        </div>
      </div>
    </div>
    <div v-if="bedrooms.length<=0" style="text-align: center;font-size: 16px;color: #333;margin-top: 20px">
        预定已截止，请联系主办方
    </div>
    <div class="bedroom" v-else>
      <div class="bedtitle" v-if="isPc">请选择房型</div>
      <div class="bedroom-item bendactive" v-for="(item,index) in bedrooms" :key="index">
        <div class="bedroom-item-type">
          <img :src="`${showImgUrl}${item.hotelImg}`" alt />
          <div class="type">
            <p>{{item.hotelType}}</p>
            <p>预定方式: {{item.sellType | measureType}}</p>
            <p>剩余间数：{{ item.sellType === 0 ? item.canBookCount : item.canBookCountTwo }}</p>
            <p>限购{{item.limits}}</p>
          </div>
        </div>
        <div class="bedroom-item-price">
          <div class="price" v-if="!isPc">¥{{item.sellType === 0 ? item.roomPrice : item.bedPrice}}</div>

          <div class="price" v-else>¥{{item.sellType === 0 ? item.roomPrice : item.bedPrice}}元/间/天</div>
          <div class="shop">
            <span @click="reduceNum(item)">-</span>
            <span>{{item.ordernum}}</span>
            <span @click="addNum(item)">+</span>
          </div>
        </div>
      </div>

      <div v-if="isPc" class="footer" @click="toRoomInfo">下一步</div>
    <div v-else class="footer" @click="toRoomInfo">下一步，填写预订信息</div>

      <div class="right" v-if="isPc">
         <h3>已选信息</h3>
        <div class="finish">
          <div class="item" v-for="(item, index) in checkedList" :key="index">
               <div>
                 <span>{{item.hotelType}}</span>
                 <span>¥{{item.sellType === 0 ? item.roomPrice : item.bedPrice}}/间/天</span>
               </div>
               <div>
                  <span>{{item.sellType | measureType}}</span>
                  <span>{{ item.ordernum }}间</span>
               </div>
          </div>
        </div>
      </div>
    </div>
   

  </div>
</template>
<script>
import http from '@/utils/http'
import apis from '@/utils/apis'
export default {
  data() {
    return {
      showMore: false,
      bedrooms: [{
        url: require('./static/bed.jpeg'),
        roomtype: '标准间',
        ordertype: '整间',
        remain: 80,
        limits: 10,
        price: 400,
        ordernum: 0
      }, {
        url: require('./static/bed.jpeg'),
        roomtype: '标准间',
        ordertype: '整间',
        remain: 80,
        limits: 10,
        price: 400,
        ordernum: 0
      }, {
        url: require('./static/bed.jpeg'),
        roomtype: '大床房',
        ordertype: '整间',
        remain: 80,
        limits: 10,
        price: 400,
        ordernum: 0
      }],
      showImgUrl: process.env.VUE_APP_SHOW_IMGURL
    }
  },
  computed: {
    meetingId() {
      return this.$store.state.meetingId || localStorage.getItem('meetingId')
    },
    currentHotel() {
      return this.$store.state.currentHotel
    },
    isPc(){
      return this.$store.state.isPc
    },
    checkedList() {
      return this.bedrooms.filter((item) => item.ordernum > 0)
    }
  },
  created() {
    this.getRoomList()
  },
  methods: {
    showDecrip(){
      this.showMore = !this.showMore
      console.log('showMore', this.showMore)
    },
    open() {

    },
    reduceNum (item) {
      if (item.ordernum <= 0) {
        item.ordernum = 0
        return
      }
      item.ordernum--
    },
    addNum (item) {
      const limitNum = item.sellType === 0 ? item.canBookCount : item.canBookCountTwo
      if (item.ordernum >= limitNum) {
        item.ordernum = limitNum;
        return
      }
      item.ordernum++
    },
    goMap(dizhi) {
      // 判断手机
      function detectVersion() {
        let isAndroid, isIOS, isIOS9, version,
          u = navigator.userAgent,
          ua = u.toLowerCase();

        if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {   //android终端或者uc浏览器
          //Android系统
          isAndroid = true
        }

        if (ua.indexOf("like mac os x") > 0) {
          //ios
          var regStr_saf = /os [\d._]*/gi;
          var verinfo = ua.match(regStr_saf);
          version = (verinfo + "").replace(/[^0-9|_.]/ig, "").replace(/_/ig, ".");
        }
        var version_str = version + "";
        if (version_str != "undefined" && version_str.length > 0) {
          version = parseInt(version)
          if (version >= 8) {
            // ios9以上
            isIOS9 = true
          }
          else {
            isIOS = true
          }
        }
        return { isAndroid, isIOS, isIOS9 }
      }
      // this.$router.push('/map?dizhi='+dizhi)
      // 创建地址解析器实例
      var myGeo = new BMap.Geocoder();
      // 将地址解析结果显示在地图上，并调整地图视野
      myGeo.getPoint(dizhi, (point) => {
        if (point) {
          console.log('point', point)
          // 定位当前位置
          if (point) {
            var scheme = '';

            // urlObject 是我这边地址栏查询参数对象
            // var queryStr = '?origin=name:我的位置|latlng:' + latCurrent + ',' + lngCurrent + '&destination=' + urlObject.lat + ',' + urlObject.lng + '&region=' + urlObject.city + '&coord_type=bd09ll&mode=driving';
            // var queryStr = `?origin=latlng:34.264642646862,108.95108518068|name:我的位置&destination=${dizhi}&mode=driving&region=${dizhi}&coord_type=bd09ll&mode=driving`;
            var queryStr = `?destination=${dizhi}&mode=driving&region=${dizhi}&coord_type=bd09ll&mode=driving`;

            if (detectVersion().isAndroid) {
              // android 端
              scheme = 'bdapp://map/direction' + queryStr;
            } else {

              // ios 端
              scheme = 'baidumap://map/direction' + queryStr;
            }

            // 主要实现代码
            window.location.href = scheme;

            var startTime = Date.now();
            var count = 0;
            var endTime = 0;

            var t = setInterval(function () {
              count += 1;
              endTime = Date.now() - startTime;
              if (endTime > 800) {
                clearInterval(t);
              }
              if (count < 30) return;
              if (!(document.hidden || document.webkitHidden)) {
                window.location.href = 'http://api.map.baidu.com/direction' + queryStr + '&output=html';
              }
            }, 20);

            window.onblur = function () {
              clearInterval(t);
            };
          } else {
            alert('获取不到定位，请检查手机定位设置');
          }
        }
      },
        dizhi);
      // 测试
      // function wakeBaidu() {
      //   var geolocation = new BMap.Geolocation();
      //   geolocation.getCurrentPosition(function (result) {
      //     if (this.getStatus() == BMAP_STATUS_SUCCESS) {
      //       var latCurrent = result.point.lat; //获取到的纬度
      //       var lngCurrent = result.point.lng; //获取到的经度
      //       if (latCurrent && lngCurrent) {
      //         var scheme = '';

      //         // urlObject 是我这边地址栏查询参数对象
      //         var queryStr = '?origin=name:我的位置|latlng:' + latCurrent + ',' + lngCurrent + '&destination=' + urlObject.lat + ',' + urlObject.lng + '&region=' + urlObject.city + '&coord_type=bd09ll&mode=driving';

      //         if (isIOS()) {
      //           // ios 端
      //           scheme = 'baidumap://map/direction' + queryStr;
      //         } else {
      //           // android 端
      //           scheme = 'bdapp://map/direction' + queryStr;
      //         }

      //         // 主要实现代码
      //         window.location.href = scheme;

      //         var startTime = Date.now();
      //         var count = 0;
      //         var endTime = 0;

      //         var t = setInterval(function () {
      //           count += 1;
      //           endTime = Date.now() - startTime;
      //           if (endTime > 800) {
      //             clearInterval(t);
      //           }
      //           if (count < 30) return;
      //           if (!(document.hidden || document.webkitHidden)) {
      //             window.location.href = 'http://api.map.baidu.com/direction' + queryStr + '&output=html';
      //           }
      //         }, 20);

      //         window.onblur = function () {
      //           clearInterval(t);
      //         };
      //       } else {
      //         alert('获取不到定位，请检查手机定位设置');
      //       }
      //     }
      //   });
      // }
    },
    toRoomInfo() {
      if (!this.checkedList.length) {
        this.$alert( '请选择房间', '',{
            showClose: false
        })
      } else {
        console.log(this.checkedList, '2222')
        const currentRoom = { roomList: this.checkedList, totalPrice: 0,hotelName: this.currentHotel.hotelName }
        this.$store.commit('SET_CURRENT_ROOM', currentRoom)
        // return
        this.$router.push('/hotel_order')
      }
    },
    async getRoomList() {
      const res = await http.get(`${apis.getRoomList}/${this.currentHotel.id}`)
      // console.log(res)
      const list1 = res.HotelRoomList || [];
      let endtime = ''
      const list = list1.filter(item=>{
          if(item.bookEndDate){
              endtime=new Date(item.bookEndDate.replace(/\-/g,'/')).getTime()
          }else{
              endtime=new Date(JSON.parse(localStorage.getItem('meeting')).endTime.split(' ')[0].replace(/\-/g,'/')).getTime()
              console.log(endtime)
          }
          let nowtime=new Date().getTime()
          return endtime-nowtime>=0
          
      })
      list.forEach((item) => {
        this.$set(item, 'ordernum', 0)
      })
      this.bedrooms = list
    }
  }
}
</script>
<style lang="stylus" scoped>
.hotel {
  min-height: 100vh;
  padding-bottom: 100px;
  box-sizing: border-box;
}

.banner {
  width: 100%;
  background: #ffffff;
  border-bottom: 1px solid rgba(199, 199, 199, 1);

  img {
    width: 100%;
  }
}

.hotel-name {
  height: 93px;
  margin: 0 20px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  .h-name {
    width: 100%;
    font-size: 34px;
    color: #000;
  }

  .star {
    font-size: 34px;
    color: #FF4E00;
  }
}

.instruction {
  height: 86px;
  margin: 0 20px;
  padding: 0 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #363636;
  font-size: 26px;
  border-top: 1px solid rgba(199, 199, 199, 1);
  &.detail-div {
    height: auto;
    padding: 10px;
    &.height-limit {
      height: 86px;
      overflow-y: hidden;
      .detail-p {
        max-width: 566px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding-left: 14px;
      }
    }
    .detail-p {
      max-width: 566px;
      padding-left: 14px;
      height: auto;
      line-height 50px
    }
  }
  div {
    display: flex;
    align-items: center;

    .address-p {
      max-width: 566px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding-left: 14px;
    }
  }

  img {
    width: 28px;
  }

  span {
    color: #B0B0B0;
    font-size: 26px;
  }
}

.bedroom {
  margin-top: 23px;

  .bedroom-item {
    display: flex;
    padding: 27px 22px 25px;
    justify-content: space-between;
    background: #fff;
    border-bottom: 1px solid rgba(199, 199, 199, 1);

    .bedroom-item-type {
      display: flex;

      .type {
        p {
          color: #737373;
          font-size: 26px;
        }

        p:nth-of-type(1) {
          font-size: 34px;
          color: #000;
        }

        p:nth-of-type(2) {
          font-size: 26px;
          color: #FF4E00;
        }
      }

      img {
        width: 160px;
        height: 160px;
        margin-right: 20px;
      }
    }

    .bedroom-item-price {
      height: 160px;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      justify-content: space-between;

      .price {
        color: #FF4E00;
        font-size: 34px;
      }

      .shop {
        width: 140px;
        height: 45px;
        border: 1px solid rgba(176, 176, 176, 1);
        color: #272727;
        font-size: 30px;

        span {
          display: inline-block;
          width: 37px;
          height: 45px;
          text-align: center;
        }

        span:nth-of-type(2) {
          width: 60px;
          text-align: center;
          border-left: 1px solid rgba(176, 176, 176, 1);
          border-right: 1px solid rgba(176, 176, 176, 1);
          color: #FF4E00;
        }
      }
    }
  }
}

.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 80px;
  line-height: 80px;
  background: #2852A6;
  color: #ffffff;
  font-size: 30px;
  text-align: center;
}

@media screen and (min-width: 800px) {
  .hotel {
    position relative
    width: 900px;
    margin: 0 auto;
    min-height: 100vh;
    background: #fff;
    box-sizing: border-box;
    padding-bottom: 100px;
  }

  .banner {
    width auto
    background: #ffffff;
    border-bottom: 1px solid rgba(199, 199, 199, 1);
    display flex
    padding 30px 0
    margin 0 30px
    padding-bottom 15px
    >img {
      width: 270px;
      height 180px
    }
    .detail{
      flex 1
    }
  }

  .hotel-name {
    height: 52px;
    margin: 0 20px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .h-name {
      width: 100%;
      font-size: 20px;
      color: #000;
    }

    .star {
      font-size: 20px;
      color: #FF4E00;
    }
  }

  .instruction {
    height: 80px;
    margin: 0 20px;
    padding: 0 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #363636;
    font-size: 14px;
    border-top: 1px solid rgba(199, 199, 199, 1);
    &.detail-div {
      height: auto;
      padding: 10px;
      &.height-limit {
        height: 30px;
        overflow-y: hidden;
        .detail-p {
          max-width: 566px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          padding-left: 14px;
        }
      }
      .detail-p {
        max-width: 566px;
        padding-left: 14px;
        height: auto;
        line-height 50px
      }
    }
    img {
      width 16px
    }
    div {
      display: flex;
      align-items: center;
      line-height 20px

      p {
        max-width: 566px;
        overflow: auto;
        white-space: normal;
        text-overflow: normal;
        padding-left: 14px;
      }

    }

    img {
      width: 14px;
    }

    span {
      color: #B0B0B0;
      font-size: 20px;
      display none
    }
  }
  .two{
    height 50px
  }

  .bedroom {
    position relative
    margin 0 30px
    margin-top: 23px;
    .bedtitle{
        font-weight 700
        font-size 25px
    }
    .bedroom-item {
      border-radius 10px
      width 470px
      height 130px
      margin-top 20px
      display: flex;
      padding:10px;
      justify-content: space-between;
      background: #fff;
      border 1px solid  #C7C7C7
      .bedroom-item-type {
        display: flex;

        .type {
          p {
            color: #737373;
            font-size: 16px;

          }

          p:nth-of-type(1) {
            font-size: 20px;
            color: #000;
            font-weight 700
          }

          p:nth-of-type(2) {
            font-size: 18px;
            color: #FF4E00;
          }
        }

        img {
          width: 130px;
          height 130px
          margin-right: 20px;
        }
      }

      .bedroom-item-price {
        height: 100px;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: space-between;

        .price {
          color: #FF4E00;
          font-size: 18px;
        }

        .shop {
          width: 96px;
          height: 30px;
          line-height 30px
          border-radius 5px
          border: 1px solid rgba(176, 176, 176, 1);
          color: #272727;
          font-size: 16px;

          span {
            display: inline-block;
            width: 30px;
            height: 30px;
            text-align: center;
          }

          span:nth-of-type(2) {
            width: 30px;
            text-align: center;
            border-left: 1px solid rgba(176, 176, 176, 1);
            border-right: 1px solid rgba(176, 176, 176, 1);
            color: #FF4E00;
          }
        }
      }
    }
    .bendactive{
         border: 1px solid #2852A6;
    }
    .right{
      position absolute
      top 0
      right 0
      h3{
        font-weight 700
        font-size 25px
      }
    }
    .finish{
      width: 290px;
      // height: 130px;
      background: #E2E2E2;
      font-size 18px
      padding 10px
      margin-top 20px
      .item {

        border-bottom: 1px dashed #989898;
        div{
          line-height 30px
          display flex
          justify-content space-between
        }
      }
    }
  }

  .footer {
    position: relative;
    left: 100px;
    top: 20px;
    width: 188px;
    height: 48px;
    line-height: 48px;
    background: #2852A6;
    color: #ffffff;
    font-size: 20px;
    text-align: center;
    border-radius 10px
  }
}
</style>


